<!-- 待确认列表 -->
<template>
  <div>
    <div class="opage">
      <!-- 资金/待确认汇款 -->
      <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.financialStoreList')"></baseBreadcrumb>
      <tableTab :val.sync="status" :list="[
        // 待确认
        { name: this.$t('message.toBeConfirmed'), value: '2' },
        // 待确认紧急
        { name: this.$t('message.toBeConfirmedUrgent'), value: '3' },]" :fun="tabClick"></tableTab>
      <div class="searchBox">
        <!-- 客户ID -->
        <el-input size="small" :placeholder="$t('message.clientID')" v-model="form.user_id" clearable></el-input>
        <!-- 汇款人 -->
        <el-input size="small" :placeholder="$t('message.remitter')" v-model="form.realname" clearable></el-input>
        <!-- 订单号 -->
        <el-input size="small" :placeholder="$t('message.orderNumber')" v-model="form.order_sn" clearable></el-input>
        <!-- 配送单号 -->
        <el-input size="small" :placeholder="$t('message.porderNumber')" v-model="form.porder_sn" clearable></el-input>
        <!-- 入金番号 -->
        <el-input size="small" :placeholder="$t('message.depositNumber')" v-model="form.serial_number"
          clearable></el-input>
        <!-- 支付方式 -->
        <el-select size="small" v-model="form.bill_method" :placeholder="$t('message.methodPayment')" @change="tabClick"
          filterable clearable>
          <el-option v-for="item in BillMethod" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
        <el-date-picker size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange" range-separator="-" v-model="value" :default-time="['00:00:00', '23:59:59']"
          :start-placeholder="$t('message.startDate')" :end-placeholder="$t('message.dateClosed')" clearable>
        </el-date-picker>
        <div class="btns">
          <!-- 筛选 -->
          <el-button size="small" type="primary" @click="tabClick">{{
            $t("message.filter")
          }}</el-button>
          <!-- 批量确认 -->
          <el-button size="small" @click="BatchConfirmation" class="primary" v-if="isAuth(320)">{{
            $t("message.BatchConfirmation")
          }} ({{ multipleSelection.length }})</el-button>
          <!-- 批量回退 -->
          <el-button size="small" type="primary" class="dark" @click="batchRollback" v-if="isAuth(322)">{{
            $t("message.batchRollback")
          }}({{ multipleSelection.length }})</el-button>
          <!-- 批量0 -->
          <el-button size="small" type="danger" class="danger" @click="batch0Queren" v-if="isAuth(322)">一括0円反映({{
            multipleSelection.length }})</el-button>
        </div>
      </div>

      <div>
        <el-table class="tableMy" :data="tableData"
          :header-cell-style="{ 'text-align': 'center', background: '#EDEFF4' }" :cell-style="{
            'text-align': 'center',
          }" @selection-change="handleSelectionChange" ref="multipleTable" @cell-click="labelSelection"
          :row-class-name="tableRowClassName" border max-height="900">
          <el-table-column type="selection" width="120">
          </el-table-column>
          <el-table-column prop="rowNumber" width="50" label="No">
          </el-table-column>
          <!-- 提出时间 -->
          <el-table-column property="created_at" :label="$t('message.forwardTime')" width="100"></el-table-column>
          <!-- 预计到账时间 -->
          <el-table-column property="predict_arrival_at" :label="$t('message.estimatedTimeOfArrival')" width="100">
            <template slot="header" slot-scope="scope">
              <div style="cursor: pointer;" @click="sortTime">
                {{ $t('message.estimatedTimeOfArrival') }}<i class="el-icon-sort"></i>
              </div>
            </template>
          </el-table-column>
          <!-- 客户 -->
          <el-table-column :label="$t('message.user')" width="150">
            <template slot-scope="scope">
              <div class="keHu dingDanZhiFuRuJin">
                <!--公司名  -->
                <p>{{ $t('message.company') }}: {{ scope.row.user.company }}</p>
                <!-- 名称 -->
                <p>{{ $t('message.names') }} : {{ scope.row.user ? scope.row.user.realname : '' }}</p>
                <p>ID:{{ scope.row.user_id }}</p>
                <!-- 联系方式 -->
                <el-popover popper-class="zdyPopver" placement="bottom-start" trigger="click"
                  :title="$t('message.customerContactInformation') + ':'">
                  <div class="xianShiLXXX">
                    <p>Email：{{ scope.row.user.email }}</p>
                    <p>Mobile：{{ scope.row.user.mobile }}</p>
                  </div>
                  <p class="lianXiFangShi" slot="reference">
                    {{ $t("message.contact") }}
                  </p>
                </el-popover>
                <!-- 业务员 -->
                <p>{{ $t('message.salesman') }} : {{ scope.row.y_name }}</p>
                <!-- 入金名义维护 -->
                <p>{{ scope.row.user_pay_account ? scope.row.user_pay_account.pay_account : '' }}</p>
                <p>
                  <el-button type="success" @click="depositNominalMaintenance(scope.row)" size="mini"
                    style="opacity: 0.7;" v-if="scope.row.user_pay_account">
                    {{ $t('message.depositNominalMaintenance') }}
                  </el-button>
                  <el-button type="primary" @click="depositNominalMaintenance(scope.row)" size="mini" v-else>
                    {{ $t('message.depositNominalMaintenance') }}
                  </el-button>
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 账务类别 -->
          <el-table-column property="bill_method_name" :label="$t('message.accountingCategory')"></el-table-column>
          <!-- 入金番号 -->
          <el-table-column property="serial_number" :label="$t('message.depositNumber')"></el-table-column>
          <!-- 单子信息 -->
          <el-table-column property="name" :label="$t('message.orderInformation')">
            <template slot-scope="scope">
              <span v-if="scope.row.order" style="color: red; font-size: 18px;font-weight: 700;">
                {{ scope.row.order.part_pay_status_name }}
              </span>
              <el-tag v-if="scope.row.is_resend" size="mini" type="danger" effect="dark">
                {{ $t('message.forwardOrders') }}
              </el-tag>

              <div v-if="scope.row.merge_pay">
                <!-- 合并付款 -->
                <el-popover placement="top" width="300" trigger="click">
                  <div v-for="(item, index) in mergePayData.order" :key="index"
                    style="display: flex;justify-content: space-between;margin-bottom: 5px; font-size: 15px;">
                    <span>{{ item.order_sn }}</span> <span>{{ item.order_amount }}</span>
                  </div>
                  <div style="display: flex;justify-content: space-between;font-size: 15px;">
                    <span></span> <span>
                      {{ $t('message.total') }}:
                      {{ mergePayData.total_amount }}</span>
                  </div>
                  <el-button type="primary" @click="mergePayDetail(scope.row.serial_number)" slot="reference">
                    {{ $t('message.mergePayments') }}
                  </el-button>
                </el-popover>

              </div>
              <div v-else>
                <router-link :to="'/orderDetail?order_sn=' + scope.row.order_sn" class="link" target="_blank"
                  v-if="scope.row.order_sn.substr(0, 1) != 'P'">
                  {{ scope.row.order_sn }}</router-link>
                <router-link :to="'/porderDetail?porder_sn=' + scope.row.order_sn" class="link" target="_blank" v-else>
                  {{ scope.row.order_sn }}</router-link>
              </div>
            </template>
          </el-table-column>
          <!-- 单子金额. 円 -->
          <el-table-column property="order_amount.total_amount_detail_jpy.total_amount"
            :label="$t('message.theAmountOnTheBillIsYen')">
            <template slot-scope="scope">
              <p v-if="scope.row.discountAmountJpy != false">
                {{
                  formatNumber(scope.row.discountAmountJpy[0].ultimately_amount)
                }}
              </p>
              <span v-else-if="scope.row.order_amount">{{
                formatNumber(scope.row.order_amount.total_amount_detail_jpy.total_amount)
              }}</span>
              <span v-else-if="scope.row.porder_amount">{{ formatNumber(scope.row.porder_amount.totalShouldPay_JPY)
              }}</span>
              <span v-else>{{ formatNumber(scope.row.pay_amount) }}</span>
              <!-- 实际需支付 -->
            </template>
          </el-table-column>
          <!-- 汇款信息 -->
          <el-table-column property="name" :label="$t('message.remittanceInformation')" width="150">
            <template slot-scope="scope">
              <div class="dingDanZhiFuRuJin">
                <!-- 支付方式 -->
                <p> {{ $t("message.methodPayment") }}:{{ scope.row.bill_type_name }}</p>
                <!-- 汇款人名 -->
                <p>{{ $t("message.nameRemitter") }}:{{ scope.row.pay_realname }}</p>
                <!-- 汇款金额 -->
                <p>{{ $t("message.remittanceAmount") }}:{{ formatNumber(scope.row.pay_amount) }}</p>
                <!-- 汇款截图 -->
                <myImage :imgList="scope.row.pay_image" :showDel="false"></myImage>
                <!-- 转账备注 -->
                <p>{{ $t("message.transferNote") }}:{{ scope.row.pay_remark }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- 流水匹配 -->
          <el-table-column :label="$t('message.flowMatching')">
            <template slot-scope="scope">
              <el-button type="text" @click="flowMatchingDetail(scope.row)">{{ $t('message.detail') }}</el-button>
            </template>
          </el-table-column>
          <!-- 客户余额 -->
          <el-table-column :label="$t('message.customerBalance')">
            <template slot-scope="scope">
              {{ formatNumber(scope.row.user.balance) }}
            </template>
          </el-table-column>
          <!-- 可赊账金额 -->
          <el-table-column :label="$t('message.creditAmount')">
            <template slot-scope="scope">
              {{ formatNumber(scope.row.user.credit) }}
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column property="name" :label="$t('message.operation')">
            <template slot-scope="scope">
              <div class="btnGroup">
                <!-- 修改 -->
                <el-button size="small" type="success" @click="xiuGai(scope.row)" v-if="isAuth(321)">{{
                  $t("message.edit")
                }}</el-button>

              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="allpag">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
          :page-sizes="[20, 30, 50, 100]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 弹框 -->
      <zDialog ref="dialog" :config="config">
        <div class="editForm">
          <el-form ref="ruleForm" :model="aProductInformation" :rules="rules" label-position="left" label-width="128px">
            <!-- 汇款人 -->
            <el-form-item :label="$t('message.theRemitter') + ':'" prop="pay_realname">
              <el-input v-model="aProductInformation.pay_realname"></el-input>
            </el-form-item>
            <!-- 汇款金额(円)-->
            <el-form-item :label="$t('message.remittanceAmount_yen') + ':'" prop="pay_amount">
              <el-input v-model="aProductInformation.pay_amount"></el-input>
            </el-form-item>
            <!--预计到账时间-->
            <el-form-item :label="$t('message.estimatedTimeOfArrival') + ':'" prop="predict_arrival_at">
              <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                v-model="aProductInformation.predict_arrival_at" clearable style="width: 100%;">
              </el-date-picker>
            </el-form-item>
            <!-- 支付方式 -->
            <el-form-item :label="$t('message.methodPayment') + ':'" prop="bill_method">
              <el-select v-model="aProductInformation.bill_method" :placeholder="$t('message.methodPayment')">
                <el-option v-for="item in BillMethod" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 汇款截图 -->
            <el-form-item :label="$t('message.remittanceScreenshots') + ':'">
              <div class="imgUp">
                <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                  :on-success="handleAvatarSuccess" name="file" accept=".jpg,.jpeg,.png"
                  :before-upload="beforeAvatarUpload">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-image :src="aProductInformation.pay_image" v-if="aProductInformation.pay_image"
                  style="width: 80px; height: 80px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                  <div slot="placeholder">
                    <i class="el-icon-loading"></i>
                  </div>
                </el-image>
              </div>
            </el-form-item>
            <!-- 转账备注 -->
            <el-form-item :label="$t('message.transferNote') + ':'" prop="pay_remark">
              <el-input class="remarksTextBox" type="textarea" v-model="aProductInformation.pay_remark"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </zDialog>
    </div>
    <!-- 流水对比 -->
    <flowMatching ref="flowMatching" :detail="itemDetail" :BillMethod="BillMethod" />
    <!--入金名义维护  -->
    <nominalSetting ref="nominalSetting" :detail="itemDetail" />
  </div>
</template>
<script>
let loadingInstance;
import myImage from "@/components/uploadFile/uploadFile.vue";
import tableTab from "../components/tableTab.vue";
import flowMatching from './flowMatching'
import nominalSetting from './nominalSetting'

export default {
  data() {
    return {
      status: '',
      activeName: "",
      value: "",
      form: {
        page: 1,
        pageSize: 20,
        order_by: 'created_at'
      },
      total: 0,
      loading: null,
      tableData: [],
      BillMethod: [], //支付方式列表
      //单个商品信息
      aProductInformation: {
        pay_realname: "",
        pay_amount: "",
        bill_method: "",
        pay_image: "",
        pay_remark: "",
      },
      tabList: [
        // 全部汇款
        // { name: this.$t("message.allOfTheRemittance"), value: "" },
        // 待确认
        { name: this.$t("message.toBeConfirmed"), value: "2" },
        // 待确认紧急
        { name: this.$t("message.toBeConfirmedUrgent"), value: "3" },
      ], //tab列表
      // 修改商品表单验证
      rules: {
        pay_realname: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        pay_amount: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        bill_method: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        pay_image: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        pay_remark: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        predict_arrival_at: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
      },
      config: {
        top: "20vh",
        width: "536px",
        autoClose: false,
        // 修改：
        title: this.$t("message.edit"),
        btnTxt: [this.$t("message.confirm"), this.$t("message.cancel")],
      },
      multipleSelection: [],//选中的
      loadingInstance: null,//进度条用的
      i: 0,
      itemDetail: {},//流水对比
      mergePayData: {},// 合并付款
    };
  },
  components: {
    myImage,
    tableTab,
    flowMatching,
    nominalSetting,
  },
  computed: {},
  mounted() {
    this.getData();
    this.getbillMethods();
    this.unConfirmListNum()
  },
  methods: {
    // 标记颜色
    tableRowClassName({ row, rowIndex }) {
      let total_amount = 0
      if (row.order_amount) {
        total_amount = row.order_amount.total_amount_detail_jpy.total_amount
      } else if (row.porder_amount) {
        total_amount = row.porder_amount.totalShouldPay_JPY
      } else {
        total_amount = row.pay_amount
      }
      if ((row.user.balance + row.user.credit) >= total_amount) {
        return 'warning-row';
      } else if ((row.user.balance + row.user.credit + row.pay_amount) < (total_amount)) {
        return 'warning';
      }
      return '';
    },
    // 获取数据
    getData() {
      if (!this.value || this.value.length == 0) {
        this.form.start_time = null;
        this.form.end_time = null;
      } else {
        this.form.start_time = this.value[0];
        this.form.end_time = this.value[1];
      }
      this.tableData = []
      this.$api.financialApi.billunConfirmList(this.form).then((res) => {
        // console.log("事件名", res.data.data);
        if (res.code != 0) return this.$message.error(res.msg);
        res.data.data.forEach(item => {
          //  入金名义 查找
          item.user_pay_account = {}
          item.user_pay_account = item.user.user_pay_account.find(items => items.bill_method == item.bill_method)
          if (item.discountAmountJpy != false) {
            item.discountAmountJpy.forEach(items => {
              items.ultimately_amount = (items.ultimately_amount - 0).toFixed(0)
            })
          }
        })
        // 接下来的操作
        this.tableData = res.data.data;
        this.total = res.data.total
        this.$forceUpdate();
      });
    },
    // 正序或者倒序
    sortTime() {
      this.form.order_by == 'predict_arrival_at' ? this.form.order_by = 'created_at' : this.form.order_by = 'predict_arrival_at'
      this.getData()
    },
    // 切换tabs
    tabClick() {
      if (this.status == 3) {
        // this.form.status = 2
        this.form.is_urgent = 1
      } else {
        // this.form.status = this.status
        this.form.is_urgent = ''
      }
      this.form.page = 1;
      this.getData()
    },
    // 待确认汇款列表统计
    unConfirmListNum() {
      this.$api.tabTotalApi.unConfirmListNum().then(res => {
        this.tabList[0].name = this.$t("message.toBeConfirmed") + `(${res.data[0].num})`
        this.tabList[1].name = this.$t("message.toBeConfirmedUrgent") + `(${res.data[1].num})`
      })
    },
    // 获取支付列表
    getbillMethods() {
      this.$api.financialApi.billBillMethod().then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.msg);
        res.data.unshift(
          { key: '', value: "すべて", is_bank: 0 }
        )
        this.BillMethod = res.data;
      });
    },
    resetFilter() {
      this.form = {};
      this.value = [];
    },
    handleAvatarSuccess(res, file) {
      console.log("res", res);
      this.loading.close();
      this.aProductInformation.pay_image = res.data;
      this.validateField("pay_image", "ruleForm");
    },
    // 手动触发表单验证
    validateField(type, formRef) {
      if (this.aProductInformation[type])
        this.aProductInformation[type] = this.aProductInformation[type].trim();
      this.$refs[formRef].validateField(type, (v) => {
        if (v == "") {
        } else {
        }
        this.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      //console.log(file.type);
      if (!isJPG) {
        this.$message.error(this.$t("message.pleaseUploadPictures"));
        return isJPG;
      }
      this.loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    // 修改订单
    xiuGai(row) {
      this.aProductInformation = JSON.parse(
        JSON.stringify({
          id: row.id,
          pay_realname: row.pay_realname,
          pay_amount: row.pay_amount,
          bill_method: row.bill_method,
          pay_image: row.pay_image,
          pay_remark: row.pay_remark,
          predict_arrival_at: row.predict_arrival_at,
        })
      );
      this.$refs.dialog.open(
        "",
        () => {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              this.$api.financialApi
                .billUpdatePayInfo(this.aProductInformation)
                .then((res) => {
                  ////console.log('事件名',res)
                  if (res.code != 0) return this.$message.error(res.msg);
                  this.getData();
                  this.unConfirmListNum()
                  this.$refs.dialog.close();
                });
            } else {
            }
          });
        },
        () => {
          // 点击取消事件
        }
      );
    },

    // 选中的
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getData();
    },
    //批量确认
    BatchConfirmation() {
      // if (this.multipleSelection == false) return this.$message.error(this.$t('message.selectableOperationalList'))
      this.$confirm(
        this.$t(
          "message.afterConfirmationTheRemittanceAmountWillBeReflectedInTheCustomerBalancePleaseBeCareful"
        ),
        // 确认提醒
        this.$t("message.confirmToRemind"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.openFullScreen()
          this.billConfirm(this.multipleSelection[this.i].id)
        })
        .catch(() => { });
    },
    // 确认
    billConfirm(id) {
      this.$api.financialApi.billConfirm({ id }).then((res) => {
        if (this.multipleSelection.length == this.i + 1) {
          this.i = 0;
          loadingInstance.close();
          this.getData();
          this.unConfirmListNum()
        } else {
          this.i++;
          this.openFullScreen();
          this.billConfirm(this.multipleSelection[this.i].id);
        }
        // if (res.code != 1) return this.$message.error(res.message);
      });
    },
    //批量回退
    batchRollback() {
      if (this.multipleSelection == false) return false
      this.$confirm(
        this.$t(
          "message.afterConfirmationThePackingListWillBeReturnedToTheStateToBeRemittedPleaseOperateWithCaution"
        ),
        // 汇款回退提醒
        this.$t("message.remittanceReturnReminder"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.openFullScreen()
          this.billBackToUnPaid(this.multipleSelection[this.i].id)

        })
        .catch(() => { });

    },
    // 批量回退
    billBackToUnPaid(id) {
      this.$api.financialApi.billBackToUnPaid({ id }).then((res) => {
        if (this.multipleSelection.length == this.i + 1) {
          this.i = 0;
          loadingInstance.close();
          this.getData();
          this.unConfirmListNum()
        } else {
          this.i++;
          this.openFullScreen();
          this.billBackToUnPaid(this.multipleSelection[this.i].id);
        }
        // if (res.code != 1) return this.$message.error(res.message);
      });
    },
    // 批量确认金额0订单
    batch0Queren() {
      if (this.multipleSelection == false) return false
      this.$confirm(
        this.$t(
          "message.afterConfirmationTheRemittanceAmountWillBeReflectedInTheCustomerBalancePleaseBeCareful"
        ),
        // 汇款回退提醒
        this.$t("message.remittanceReturnReminder"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.openFullScreen()
          this.batch0QuerenUnPaid(this.multipleSelection[this.i])

        })
        .catch(() => { });
    },
    // 批量确认金额0订单
    batch0QuerenUnPaid(row) {
      let datas = {
        id: row.id,
        pay_realname: row.pay_realname,
        pay_amount: 0,
        bill_method: row.bill_method,
        pay_image: row.pay_image,
        pay_remark: row.pay_remark,
      }
      this.$api.financialApi
        .billUpdatePayInfo(datas)
        .then((res) => {
          this.openFullScreen();
          this.$api.financialApi.billConfirm({ id: row.id }).then((res) => {
            if (this.multipleSelection.length == this.i + 1) {
              this.i = 0;
              loadingInstance.close();
              this.getData();
              this.unConfirmListNum()
            } else {
              this.i++;
              this.openFullScreen();
              this.batch0QuerenUnPaid(this.multipleSelection[this.i]);
            }
          });
        });



    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    openFullScreen() {
      let option = {
        lock: true,
        text: `進行中 ${this.i + 1}/${this.multipleSelection.length} 少々お待ちください...`,
        spinner: "el-icon-loading",
        background: "hsla(0,0%,100%,.1)",
      }
      loadingInstance = this.$loading(option);
    },
    // 流水对比详情
    flowMatchingDetail(item) {
      this.itemDetail = JSON.parse(JSON.stringify(item))
      this.$refs.flowMatching.dialogVisible = true
    },
    //入金名义维护
    depositNominalMaintenance(item) {
      this.itemDetail = JSON.parse(JSON.stringify(item))
      this.$refs.nominalSetting.dialogVisible = true
    },
    //合并支付待确认汇款详情
    mergePayDetail(serial_number) {
      this.$api.financialApi.mergePayDetail({ serial_number }).then((res) => {
        this.mergePayData = res.data
      })

    }

  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

/deep/.el-button {
  width: 100px !important;
  text-align: center;
  display: inline-block !important;

}

/deep/.el-checkbox__input {
  transform: scale(2);
}

/deep/.el-table-column--selection {
  .cell {
    width: 100px !important;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

}

/deep/.el-table__header {
  .el-table-column--selection {
    .cell {
      width: 100px !important;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }
}

.opage {
  background-color: #f8f8f8;
  padding: 20px;
}

.searchBox {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  // position: sticky;
  left: 0;
  top: 0;
  z-index: 999;
  background-color: #f5f5f5;

  /deep/.el-select {

    i {
      margin-top: -8px;
    }

  }

  >* {
    flex: 0 0 180px;
    margin-right: 20px;
  }

  .el-date-editor {
    flex: 0 0 389px;

  }

  /deep/.el-input__inner {
    margin-bottom: 15px;

  }

  .btns {
    flex: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-left: auto;
    padding: 0;
    margin-bottom: 15px;
  }
}

/deep/.tableMy {
  th {
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }

  p {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }

  .keHu {
    p {
      text-align: center;
    }
  }

  .dingDanZhiFuRuJin {
    p {
      text-align: left;
    }
  }

  .lianXiFangShi {
    color: #2c96e7;
    cursor: pointer;
  }

  .link {
    color: #fa5058;
  }

  .btnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .el-button {
      display: flex;
      margin: 0 0 8px 0;
    }
  }
}

.editForm {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px 24px 1px;

  .el-select {
    width: 100%;
  }

  .imgUp {
    display: flex;
    align-items: flex-start;

    /deep/.avatar-uploader .el-upload {
      width: 80px;
      height: 80px;
      margin-right: 10px;
      border: 1px solid #e8e8e8;
      border-radius: 5px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      background-color: white;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }

    /deep/.el-image {
      width: 80px !important;
      height: 80px !important;
    }

    /deep/.imgBox {
      height: 80px;
    }
  }

  /deep/.remarksTextBox {
    .el-textarea__inner {
      height: 100px;
      background: #ffffff;
      border: 1px solid #edeff4;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
      padding: 12px 16px;
    }
  }
}

.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}
</style>
<style lang="scss">
.zdyPopver {
  padding: 0;

  .el-popover__title {
    padding: 13px 16px;
    background: #f8f8f8;
    border-radius: 4px 4px 0px 0px;
    margin-bottom: 0;
  }

  .popper__arrow {
    display: none;
  }
}

.xianShiLXXX {
  padding: 16px;

  p {
    font-size: 14px;
    line-height: 20px;
  }


}

.warning-row {
  background-color: rgba(210, 242, 224, 0.5) !important;
}

.warning {
  background-color: rgba(242, 210, 235, 0.5) !important;
}

.el-table tbody .warning:hover>td {
  background-color: rgba(242, 210, 235, 0.5) !important;
}

.el-table tbody .warning-row:hover>td {
  background-color: rgba(210, 242, 224, 0.5) !important;
}

.danger {
  background-color: #f2ae0f !important;
  border: #f2ae0f;
}
</style>